import Text from 'components/Text/Text';
import React, { useContext, useMemo } from 'react';
import {
	IVideosAssignmentContext,
	VideosAssignmentContext,
} from '../../../../videosAssignmentState/videosAssignmentContext';
import Video from './components/Video';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import classNames from 'classnames';
import style from './Videos.module.scss';

const Videos: React.FC = () => {
	const { setIDsSelectedRestaurants, IDsSelectedRestaurants, searchStringForVideos, videos } =
		useContext<IVideosAssignmentContext>(VideosAssignmentContext);

	const filteredVideos = useMemo(() => {
		if (searchStringForVideos) {
			const updatedVideos = videos.map((el) => {
				const filteredVideosByName = el.videos.filter((video) =>
					video.videoName?.toLowerCase().includes(searchStringForVideos.toLowerCase()),
				);
				return { ...el, videos: filteredVideosByName };
			});
			return updatedVideos;
		}
		return videos;
	}, [searchStringForVideos, videos]);

	const changeCloseStatus = (restaurantID: string) => {
		const copyIDsSelectedRestaurants = { ...IDsSelectedRestaurants };
		copyIDsSelectedRestaurants[restaurantID] = !copyIDsSelectedRestaurants[restaurantID];
		setIDsSelectedRestaurants(copyIDsSelectedRestaurants, false);
	};

	const deleteRestaurant = (restaurantID: string) => {
		const copyIDsSelectedRestaurants = { ...IDsSelectedRestaurants };
		delete copyIDsSelectedRestaurants[restaurantID];
		setIDsSelectedRestaurants(copyIDsSelectedRestaurants, true);
	};

	return (
		<div data-test="Videos">
			{filteredVideos.map((el) => {
				const wrapperClasses = classNames(style.wrapper, {
					[style.collapsedWrapper]: !IDsSelectedRestaurants[el.restaurantId],
				});

				return (
					<div key={el.restaurantId + 'mainDisplayVideosTab'}>
						<div className={wrapperClasses}>
							<div className={style.category}>
								<div className={style.name} onClick={() => changeCloseStatus(el.restaurantId)}>
									<Text
										translationKey={el.restaurantAddress}
										theme={!IDsSelectedRestaurants[el.restaurantId] ? 'secondary' : 'contrast'}
										withTooltip={true}
									/>
									<svg className={style.pointerIcon}>
										<use xlinkHref={`${breadcrumbs}#next`} />
									</svg>
								</div>
								<svg className={style.closeIcon} onClick={() => deleteRestaurant(el.restaurantId)}>
									<use xlinkHref={`${breadcrumbs}#close`} />
								</svg>
							</div>
							<div className={style.subcategory}>
								{el.videos.length ? (
									<Video data={el.videos} restaurantID={el.restaurantId} />
								) : (
									<Text
										translationNameSpace="listing"
										translationKey="noVideosLabel"
										theme="errorDark"
										weight="bold"
										align="center"
									/>
								)}
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default Videos;
